import { BSON, EJSON, ObjectId } from "bson";

export function getAnonymousUser() {
    const bytes = BSON.serialize({ _id: new ObjectId() });
    const doc = BSON.deserialize(bytes);
    const obj = JSON.parse(EJSON.stringify(doc));
    const userId = obj["_id"]["$oid"];

    return userId;
}
